import styles from './checkDetail.module.scss';
import cn from 'classnames';
import ActionButton from './ActionButton';
import CheckDetailContent from './Sections';

const CheckDetails = props => {
  const {
    selectedCheck,
    currency,
    supportsTipsOnTotalAmount,
    suppressTipsOnFireBoard,
    checksRowData,
    currentMode,
    updateOrderStatus,
    markOrderAsPickedUp,
    isFlip,
    setIsFlip,
    setPopup,
    setIsExpanded,
    setTraceClick,
    handleExpandedRightSection,
  } = props;
  const selectedItem = checksRowData.find(el => el.id === selectedCheck);

  return (
    <div className={cn('h-100 col-12', styles.CheckDetailContainer)}>
      <div className={cn(styles.flipContainer, { [styles.flipped]: isFlip })}>
        <div
          className={cn(
            'w-100 h-100',
            styles.frontSide,
            styles.side,
            styles.bodyTextFont
          )}
        >
          <CheckDetailContent
            selectedItem={selectedItem}
            setIsFlip={setIsFlip}
            isFlip={isFlip}
            currency={currency}
            supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
            suppressTipsOnFireBoard={suppressTipsOnFireBoard}
            mode={currentMode}
            setPopup={setPopup}
            setIsExpanded={setIsExpanded}
            setTraceClick={setTraceClick}
          />
        </div>
        <div className={cn(styles.side, styles.backSide)}>
          <ActionButton
            mode={currentMode}
            setIsFlip={setIsFlip}
            item={selectedItem}
            updateOrderStatus={updateOrderStatus}
            markOrderAsPickedUp={markOrderAsPickedUp}
            handleExpandedRightSection={handleExpandedRightSection}
          />
        </div>
      </div>
    </div>
  );
};

export default CheckDetails;
